import React from 'react';
import { Button, Icon } from 'antd'
import './deleteButton.css';

export const DeleteButton = ({onClick, className}) => (
  <Icon type="delete" className="delete-button__icon" onClick={onClick} />
);



// WEBPACK FOOTER //
// ./src/components/common/deleteButton/deleteButton.js